import ApiGateway from './apigateway'
import AppSync from './appsync'
import AppSyncResolver from './appsync-resolver'
import DynamoDB from './dynamodb'
import ECSCluster from './ecs-cluster'
import ECSService from './ecs-service'
import ELBApplicationLoadBalancer from './elb-application-load-balancer'
import ELBGatewayLoadBalancer from './elb-gateway-load-balancer'
import ELBNetworkLoadBalancer from './elb-network-load-balancer'
import ELBTargetGroup from './elb-target-group'
import KinesisAnalytics from './kinesis-analytics'
import KinesisDataStream from './kinesis-datastream'
import KinesisFirehose from './kinesis-firehose'
import Lambda from './lambda'
import OpenSearch from './opensearch'
import RDSInstance from './rds-instance'
import RDSProxy from './rds-proxy'
import RDSCluster from './rds-cluster'
import SNS from './sns'
import SQS from './sqs'
import StepFunctions from './stepfunctions'

const TotalMetrics = {
  APIGatewayRest: ApiGateway,
  APIGatewayHttp: ApiGateway,
  AppSyncAPI: AppSync,
  AppSyncResolver,
  DynamoDB,
  ECSCluster,
  ECSService,
  ELBApplicationLoadBalancer,
  ELBGatewayLoadBalancer,
  ELBNetworkLoadBalancer,
  ELBTargetGroup,
  KinesisAnalytics,
  KinesisDataStream,
  KinesisFirehose,
  Lambda,
  OpenSearch,
  RDSCluster,
  RDSInstance,
  RDSProxy,
  SNS,
  SQS,
  StepFunctions
}

export default TotalMetrics
